import { defineMessages } from 'react-intl'

export default defineMessages({
  active: {
    id: 'components.OrganizationPicker.Card.active',
    defaultMessage: 'ACTIVE',
  },
  switchHere: {
    id: 'components.OrganizationPicker.Card.switchHere',
    defaultMessage: 'Switch here',
  },
  crossOrgUser: {
    id: 'components.OrganizationPicker.Card.crossOrgUser',
    defaultMessage: 'X-org',
  },
})
